/* GUAPI SUMMER SALE 2026 - rail quick-add v3 (production).
   v3: single-variant ("Default Title") products get NO size selector - just ADD. */
(function(){
  function wire(){
    var rail = document.getElementById('gp-sale-upsell');
    if (!rail || rail.dataset.gpQuick) return;
    var cards = rail.querySelectorAll('.gp-card');
    if (!cards.length) return;
    rail.dataset.gpQuick = '1';
    cards.forEach(function(card){
      var href = card.getAttribute('href') || '';
      var hm = href.match(/\/products\/([a-z0-9\-]+)/);
      if (!hm) return;
      fetch('/products/'+hm[1]+'.js').then(function(r){return r.json()}).then(function(p){
        var av = (p.variants||[]).filter(function(v){return v.available});
        if (!av.length) return;
        var single = av.length === 1 && /^default title$/i.test(av[0].title || '');
        var box = document.createElement('div');
        box.innerHTML = (single ? '' : '<select class="gp-r-size">'+av.map(function(v){return '<option value="'+v.id+'">'+v.title+'</option>';}).join('')+'</select>')+
          '<button type="button" class="gp-r-add" data-vid="'+av[0].id+'">ADD</button>';
        box.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); }, true);
        box.querySelector('.gp-r-add').addEventListener('click', function(ev){
          ev.preventDefault(); ev.stopPropagation();
          var btn = this;
          var sel = box.querySelector('.gp-r-size');
          var vid = sel ? parseInt(sel.value, 10) : parseInt(btn.getAttribute('data-vid'), 10);
          if (!vid) return;
          btn.disabled = true; btn.textContent = 'ADDING\u2026';
          var doAdd = window.gpCartAdd || function(items, cb){ fetch('/cart/add.js', {method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({items: items})}).then(function(r){ if(!r.ok) throw 0; cb(null); }).catch(function(e){ cb(e); }); };
          doAdd([{id: vid, quantity: 1}], function(err){
            if (err) { btn.disabled = false; btn.textContent = 'ADD'; return; }
            btn.textContent = 'ADDED \u2713';
            setTimeout(function(){ btn.disabled = false; btn.textContent = 'ADD'; }, 2500);
          });
        });
        card.appendChild(box);
      }).catch(function(){});
    });
  }
  var iv = setInterval(function(){ wire(); var r = document.getElementById('gp-sale-upsell'); if (r && r.dataset.gpQuick) clearInterval(iv); }, 700);
  setTimeout(function(){ clearInterval(iv); }, 20000);
})();
